<script setup lang="ts">
import HomeCTA from "@/modules/public/components/HomeCTA.vue";
import Carousel from "@/modules/public/views/home/components/Carousel.vue";
import CallToAction from "@/modules/public/views/home/components/CallToAction.vue";
import OverTaalblobs from "@/modules/public/views/home/components/OverTaalblobs.vue";
import TaalblobsKernpunten from "@/modules/public/views/home/components/TaalblobsKernpunten.vue";
import HomeTestimonials from "@/modules/public/views/home/components/HomeTestimonials.vue";
</script>

<template>
  <Carousel />
  <CallToAction />
  <OverTaalblobs />
  <HomeTestimonials />
  <TaalblobsKernpunten />
  <HomeCTA />
</template>
